/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as ProfileRouteImport } from './routes/profile'
import { Route as DsRouteImport } from './routes/ds'
import { Route as AboutRouteImport } from './routes/about'
import { Route as IndexRouteImport } from './routes/index'
import { Route as CardsNewRouteImport } from './routes/cards.new'
import { Route as AuctionAuctionIdRouteImport } from './routes/auction.$auctionId'

const SignInRoute = SignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileRoute = ProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const DsRoute = DsRouteImport.update({
  id: '/ds',
  path: '/ds',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutRoute = AboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const CardsNewRoute = CardsNewRouteImport.update({
  id: '/cards/new',
  path: '/cards/new',
  getParentRoute: () => rootRouteImport,
} as any)
const AuctionAuctionIdRoute = AuctionAuctionIdRouteImport.update({
  id: '/auction/$auctionId',
  path: '/auction/$auctionId',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/ds': typeof DsRoute
  '/profile': typeof ProfileRoute
  '/register': typeof RegisterRoute
  '/sign-in': typeof SignInRoute
  '/auction/$auctionId': typeof AuctionAuctionIdRoute
  '/cards/new': typeof CardsNewRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/ds': typeof DsRoute
  '/profile': typeof ProfileRoute
  '/register': typeof RegisterRoute
  '/sign-in': typeof SignInRoute
  '/auction/$auctionId': typeof AuctionAuctionIdRoute
  '/cards/new': typeof CardsNewRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/ds': typeof DsRoute
  '/profile': typeof ProfileRoute
  '/register': typeof RegisterRoute
  '/sign-in': typeof SignInRoute
  '/auction/$auctionId': typeof AuctionAuctionIdRoute
  '/cards/new': typeof CardsNewRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/about'
    | '/ds'
    | '/profile'
    | '/register'
    | '/sign-in'
    | '/auction/$auctionId'
    | '/cards/new'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/about'
    | '/ds'
    | '/profile'
    | '/register'
    | '/sign-in'
    | '/auction/$auctionId'
    | '/cards/new'
  id:
    | '__root__'
    | '/'
    | '/about'
    | '/ds'
    | '/profile'
    | '/register'
    | '/sign-in'
    | '/auction/$auctionId'
    | '/cards/new'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AboutRoute: typeof AboutRoute
  DsRoute: typeof DsRoute
  ProfileRoute: typeof ProfileRoute
  RegisterRoute: typeof RegisterRoute
  SignInRoute: typeof SignInRoute
  AuctionAuctionIdRoute: typeof AuctionAuctionIdRoute
  CardsNewRoute: typeof CardsNewRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile': {
      id: '/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof ProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ds': {
      id: '/ds'
      path: '/ds'
      fullPath: '/ds'
      preLoaderRoute: typeof DsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cards/new': {
      id: '/cards/new'
      path: '/cards/new'
      fullPath: '/cards/new'
      preLoaderRoute: typeof CardsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auction/$auctionId': {
      id: '/auction/$auctionId'
      path: '/auction/$auctionId'
      fullPath: '/auction/$auctionId'
      preLoaderRoute: typeof AuctionAuctionIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AboutRoute: AboutRoute,
  DsRoute: DsRoute,
  ProfileRoute: ProfileRoute,
  RegisterRoute: RegisterRoute,
  SignInRoute: SignInRoute,
  AuctionAuctionIdRoute: AuctionAuctionIdRoute,
  CardsNewRoute: CardsNewRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
